// import React, { Suspense, useState } from "react";
// import { useSelector } from "react-redux";
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// // import Footer from "../Shared/Footer/Footer";
// import Navigation from "../Shared/Navigation/Index";
// import { SignalRProvider } from "../Utils/SignalRContext";
// // import { Box } from "@mui/material";
// import SidebarChat from "../Shared/SidebarChat";
// // import Header_logo_1 from '../images/Header_logo_1.png';
// // import { RxCross2 } from "react-icons/rx";
// import "../index.scss"
// import SidebarMenu from './../Shared/SidebarMenu/index';
// import AcademicYearProvider from "../context/AcademicYearProvider";
// import { CircularProgress } from "@mui/material";

// const Header_logo_1 = '/assets/FIG Agent.png'

// function PrivateRoute() {
//   const loggedIn = useSelector(
//     (state) => state.login?.LoginDetails?.accessToken
//   );
//   let TopMenuList = useSelector((state) => state.setting?.TopMenuList);
//   let { pathname } = useLocation();
//   let psNameMessage = pathname?.split("/")[1] === "messages"

//   const [isSidebarChatOpen, setIsSidebarChatOpen] = React.useState(); // Chat sidebar collapsed by default
//   const handleLogoClick = () => {
//     setIsOpen(false)
//     setIsSidebarChatOpen(isSidebarChatOpen ? false : true);
//   };
//   const [isOpen, setIsOpen] = useState(false);
//   if (!loggedIn) {
//     return <Navigate to="/" />;
//   }
//   return (
//     <>
//       <div
//         className="chatLogoBtn"
//         onClick={handleLogoClick}
//       >
//         <img
//           className="img-fluid"
//           src={Header_logo_1}
//           alt="FIG K12 Logo"
//         />
//       </div>
//       <div className="mainLayout">
//         <div
//           className={`wrapper ${isSidebarChatOpen ? "open" : "close"}`}
//         >
//           {TopMenuList?.filter(
//             (x) => x.menuUrl?.split("/")[1] === pathname?.split("/")[1]
//           )?.length > 0 ? (
//             <>
//               <SignalRProvider>
//                 <AcademicYearProvider>
//                   <Navigation setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
//                   <div className="mainLayout">
//                     <SidebarMenu setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
//                     <div className={`content ${isOpen ? "expanded" : "collapsed"}`}>
//                       <Suspense
//                         fallback={
//                           <div className="loader">
//                             <CircularProgress sx={{ color: "#86c65a" }} />
//                           </div>
//                         }
//                       >

//                         <Outlet />
//                       </Suspense>
//                     </div>
//                   </div>
//                 </AcademicYearProvider>
//               </SignalRProvider>
//             </>
//           ) : TopMenuList?.length > 0 ? (
//             <Navigate to={TopMenuList[0]?.menuUrl} />
//           ) : (
//             <Navigate to="/" />
//           )}
//         </div >
//         <SidebarChat isOpen={isSidebarChatOpen} psNameMessage={psNameMessage} onClose={() => setIsSidebarChatOpen(false)} />
//       </div >
//       {/* <Footer /> */}
//     </>
//   );
// }

// export default PrivateRoute;

import React, { Suspense, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
// import Footer from "../Shared/Footer/Footer";
import Navigation from "../Shared/Navigation/Index";
import { SignalRProvider } from "../Utils/SignalRContext";
// import { Box } from "@mui/material";
import SidebarChat from "../Shared/SidebarChat";
// import Header_logo_1 from '../images/Header_logo_1.png';
// import { RxCross2 } from "react-icons/rx";
import "../index.scss"
import SidebarMenu from './../Shared/SidebarMenu/index';
import AcademicYearProvider from "../context/AcademicYearProvider";
import { CircularProgress } from "@mui/material";

const Header_logo_1 = '/assets/FIG Agent.png'

function PrivateRoute() {
  const loggedIn = useSelector(
    (state) => state.login?.LoginDetails?.accessToken
  );
  const TopMenuList = useSelector((state) => state.setting?.TopMenuList || []);
  const MenuList = useSelector((state) => state.setting?.MenuList || []);
  const ReportList = useSelector((state) => state.setting?.ReportList || []);
  let { pathname } = useLocation();
  let psNameMessage = pathname?.split("/")[1] === "messages"

  const [isSidebarChatOpen, setIsSidebarChatOpen] = React.useState(); // Chat sidebar collapsed by default
  const handleLogoClick = () => {
    setIsOpen(false)
    setIsSidebarChatOpen(isSidebarChatOpen ? false : true);
  };
  const [isOpen, setIsOpen] = useState(false);

  const hasAccessToRoute = useMemo(() => {
    if (!pathname) return false;

    const path = pathname.toLowerCase();

    // Allow direct access to template view page used from dialogs,
    // independent of report menu permissions.
    if (path.startsWith("/reports/templateview")) {
      return true;
    }
    if (path.startsWith("/certificate-new/report")) {
      return true;
    }

    // Allow Super Admin access to Training Intake
    if (path.startsWith("/training-intake")) {
      return true;
    }

    const firstSegment = path.split("/")[1];

    // 1. Basic check: does first segment exist in TopMenuList?
    const topHasAccess = TopMenuList?.some(
      (x) => x?.menuUrl?.split("/")[1]?.toLowerCase() === firstSegment
    );

    if (!topHasAccess) return false;

    // 2. For settings and reports, check if the specific menu URL is allowed
    // MenuList/ReportList store URLs WITHOUT the "settings" or "reports" prefix
    // e.g., menuUrl: "courseSetting/courseLable" for path "/settings/courseSetting/courseLable"

    // Helper: normalize a menuUrl by removing leading slash and converting to lowercase
    const normalizeMenuUrl = (url) => {
      if (!url) return "";
      return url.toLowerCase().replace(/^\//, "");
    };

    // Helper: get path without the root segment (settings/reports)
    // e.g., "/settings/courseSetting/courseLable" -> "courseSetting/courseLable"
    const getPathWithoutRoot = (fullPath, root) => {
      const parts = fullPath.split("/").filter(Boolean);
      if (parts[0]?.toLowerCase() === root.toLowerCase()) {
        return parts.slice(1).join("/");
      }
      return "";
    };

    // Helper: check if a path matches a menuUrl (handles dynamic params)
    // e.g., "courseSetting/courseLable" matches "courseSetting/courseLable"
    // and "courseSetting/123" matches "courseSetting/:id" or "courseSetting"
    const pathMatchesMenuUrl = (pathWithoutRoot, menuUrl) => {
      const normalizedPath = normalizeMenuUrl(pathWithoutRoot);
      const normalizedMenuUrl = normalizeMenuUrl(menuUrl);

      // Exact match
      if (normalizedPath === normalizedMenuUrl) return true;

      // Check if path starts with menuUrl (for cases like menuUrl: "courseSetting" and path: "courseSetting/courseLable")
      if (normalizedPath.startsWith(normalizedMenuUrl + "/")) return true;

      // Check if menuUrl has dynamic params (like ":id") - compare base paths
      const pathParts = normalizedPath.split("/");
      const menuParts = normalizedMenuUrl.split("/");

      // If menuUrl has fewer parts, check if path starts with it
      if (menuParts.length <= pathParts.length) {
        const menuBase = menuParts.slice(0, menuParts.length).join("/");
        const pathBase = pathParts.slice(0, menuParts.length).join("/");
        if (menuBase === pathBase) return true;
      }

      return false;
    };

    // Helper: collect all menuUrls from MenuList/ReportList (including nested submenus)
    const collectAllMenuUrls = (list) => {
      const urls = [];
      const walk = (items) => {
        if (!items || !Array.isArray(items)) return;
        items.forEach((item) => {
          if (item?.menuUrl) {
            urls.push(item.menuUrl);
          }
          if (item?.subMenu && Array.isArray(item.subMenu)) {
            walk(item.subMenu);
          }
        });
      };
      walk(list);
      return urls;
    };

    if (firstSegment === "settings") {
      // Allow plain "/settings" if user has any settings menu
      if (path === "/settings") return MenuList?.length > 0;

      const pathWithoutSettings = getPathWithoutRoot(path, "settings");
      if (!pathWithoutSettings) return false;

      const allowedMenuUrls = collectAllMenuUrls(MenuList);
      const hasAccess = allowedMenuUrls.some((menuUrl) =>
        pathMatchesMenuUrl(pathWithoutSettings, menuUrl)
      );

      return hasAccess;
    }

    if (firstSegment === "reports") {
      // Allow plain "/reports" if user has any report menu
      if (path === "/reports") return ReportList?.length > 0;

      const pathWithoutReports = getPathWithoutRoot(path, "reports");
      if (!pathWithoutReports) return false;

      const allowedMenuUrls = collectAllMenuUrls(ReportList);
      const hasAccess = allowedMenuUrls.some((menuUrl) =>
        pathMatchesMenuUrl(pathWithoutReports, menuUrl)
      );

      return hasAccess;
    }

    return true;
  }, [pathname, TopMenuList, MenuList, ReportList]);

  if (!loggedIn) {
    return <Navigate to="/" />;
  }

  const defaultPrivatePath =
    TopMenuList && TopMenuList.length > 0 && TopMenuList[0]?.menuUrl
      ? TopMenuList[0].menuUrl
      : "/";

  return (
    <>
      <div
        className="chatLogoBtn"
        onClick={handleLogoClick}
      >
        <img
          className="img-fluid"
          src={Header_logo_1}
          alt="FIG K12 Logo"
        />
      </div>
      <div className="mainLayout">
        <div
          className={`wrapper ${isSidebarChatOpen ? "open" : "close"}`}
        >
          {hasAccessToRoute ? (
            <>
              <SignalRProvider>
                <AcademicYearProvider>
                  <Navigation setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
                  <div className="mainLayout">
                    <SidebarMenu setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
                    <div className={`content ${isOpen ? "expanded" : "collapsed"}`}>
                      <Suspense
                        fallback={
                          <div className="loader">
                            <CircularProgress sx={{ color: "#86c65a" }} />
                          </div>
                        }
                      >

                        <Outlet />
                      </Suspense>
                    </div>
                  </div>
                </AcademicYearProvider>
              </SignalRProvider>
            </>
          ) : TopMenuList?.length > 0 ? (
            <Navigate to={defaultPrivatePath} />
          ) : (
            <Navigate to="/" />
          )}
        </div >
        <SidebarChat isOpen={isSidebarChatOpen} psNameMessage={psNameMessage} onClose={() => setIsSidebarChatOpen(false)} />
      </div >
      {/* <Footer /> */}
    </>
  );
}

export default PrivateRoute;
